import {ResponsiveContent} from "../../ResponsiveNavTabs";
import React, {useRef, useState} from "react";
import {useOrder, useOrderCount, useOrderList, useOrderOrderOptions} from "./useOrder";
import {Button, ListGroup, Modal, Stack} from "react-bootstrap";
import {
    ItemLoading, MenuAdd,
    MenuBar,
    MenuClearSelectButton,
    MenuConfirmDeleteButton,
    MenuOrderBy,
    MenuSearchTerm,
    OurClearAlert, OurPagination2,
    PageTitle, SelectText, SingleText
} from "../../_components";
import {useAlert, useAuth} from "../../../context";
import {useGetJson, useLocalFilter2, useLongPress, useSelect, useTouch} from "../../../hooks";
import {isoTimestampToReadableDate, isoTimestampToReadableDateOnly} from "../admin/utilities/readableDate";
import {Formik, Form as FormikForm} from "formik";
import {Link, useNavigate} from "react-router-dom";
import {endpoints} from "../../../utils2";

export function Dispatch() {
    return <ResponsiveContent body={<DispatchBody/>}/>
}

function DispatchBody() {
    const {success} = useAlert()
    const {admin} = useAuth()

    // Get order options
    const {orderOptions, errorOrderOptions, clearErrorOrderOptions} = useOrderOrderOptions()

    // API Actions
    const {deleteItem, errorValue, clearErrorValue} = useOrder()

    // API count all items
    const {count, setCount, loadingCount, errorCount, clearErrorCount} = useOrderCount(null, true)

    // API items per page
    const {list, setList, loadingList, errorList, clearErrorList} = useOrderList(null, null, null, null, false, true)

    // Filter
    const filteredList = useLocalFilter2(list, ["shipping_name", "order_number", "status"])

    // Select
    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(list)

    function handleOnItemsDelete() {
        selList.forEach(item =>
            deleteItem(item.id).then(() => {
                setCount(count => count - 1)
                setList(prev => prev.filter(obj => obj.id !== item.id))
                success(`${item.name} has been deleted!`)
            }).catch(err => console.warn(err))
        )
        clearSelectItems()
    }

    return <Stack>

        <OurClearAlert variant="danger" msg={errorOrderOptions} onClear={clearErrorOrderOptions}/>
        <OurClearAlert variant="danger" msg={errorCount} onClear={clearErrorCount}/>
        <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>
        <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

        <PageTitle title="Dispatch">Manage {list.length} of {count} orders.</PageTitle>

        <MenuBar>
            {admin && <MenuAdd to="" icon="plus">Add</MenuAdd>}
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
            {admin && (
                <>
                    <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
                        {selList.length} {selList.length === 1 ? "row" : "rows"}
                    </MenuClearSelectButton>
                    <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={handleOnItemsDelete}>
                        {selList.length} {selList.length === 1 ? "order" : "orders"}
                    </MenuConfirmDeleteButton>
                </>
            )}
        </MenuBar>

        <ItemLoading show={loadingCount || loadingList}/>

        {list && list.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map(item => <div key={item.id}>
                        <RenderItem
                            item={item}
                            selected={isItemSelected(item.id)}
                            selectedCount={selList.length}
                            onSelect={toggleSelectItems}
                            to={`/backend/order/${item.user_id}/${item.id}`}
                            toUser={`/backend/user/${item.user_id}`}
                        />
                    </div>
                )}
            </ListGroup>
            :
            <span className="text-center">No address added yet</span>
        }

        <OurPagination2 loading={loadingCount || loadingList} itemCount={count}/>

    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to, toUser}) {
    const touch = useTouch()
    const {admin} = useAuth()
    const navigate = useNavigate()
    const [show, setShow] = useState(false)

    // Handle Dispatch modal
    const [showModal, setShowModal] = useState(false)
    const handleShowModal = () => setShowModal(true)

    const capitalize = str => str ? str.charAt(0).toUpperCase() + str.slice(1) : ""

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))


    return (

        // <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "bg-light"} ${show && "bg-light-subtle"}`}
        <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${(selected || show) && "bg-light-subtle"}`}
               onMouseEnter={() => setShow(true)}
               onMouseLeave={() => setShow(false)}>
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    <i className="bi bi-send fs-4"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="p-0 flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">Order {item.order_number}</span>
                        </Link>
                        <Link to={toUser}
                              className="p-0 flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fs-6 fw-light">{item.shipping_name}</span>
                        </Link>

                        <span className="text-wrap fs-6 fw-light">Articles: {item.count_articles}, Total: {item.total_gross.toFixed(2)} €</span>
                        <span className="text-wrap fs-6 fw-light">{isoTimestampToReadableDate(item.created_at)}</span>
                    </Stack>
                </div>
                <div className="ms-auto">
                    <Stack className="text-body-tertiary align-items-end justify-content-center" gap={0}>
                        <span className="text-wrap fw-normal text-secondary">{capitalize(item.status)} {item.shipped_at && ` (${isoTimestampToReadableDateOnly(item.shipped_at)})`}</span>
                        <span className="text-nowrap fw-normal text-secondary">{item.shipping_company}</span>
                        {/*{item.shipped_at && <span className="text-nowrap fw-normal text-secondary">Shipped at {isoTimestampToReadableDate(item.shipped_at)}</span>}*/}
                    </Stack>
                </div>
            </Stack>

            <div className="d-flex flex-column ms-auto">
                {(!touch || selected || selectedCount > 0) && admin &&
                    <Button className="link-underline link-underline-opacity-0" variant="link" onClick={() => onSelect(item.id)}>
                        <span className={`bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                    </Button>
                }
                <Button variant="link" onClick={handleShowModal}
                        className="link-underline link-underline-opacity-0">
                    <span className="bi bi-truck"></span>
                </Button>

                <Button variant="link" onClick={() => navigate(`/backend/dispatch/${item.user_id}/${item.id}`)}
                        className="link-underline link-underline-opacity-0">
                    <span className="bi bi-pencil"></span>
                </Button>
            </div>

            {showModal && <DispatchModal onClose={() => setShowModal(false)} orderId={item.id} status={item.status} track={item.shipping_track}/>}
        </Stack>
    )
}

function DispatchModal({onClose, orderId, status, track}) {
    const {authToken} = useAuth()
    const {smallEditItem} = useOrder()
    const {success, error} = useAlert()

    const [orderStatus, loading, errorStatus, clearErrorStatus] = useGetJson(endpoints.order.status(), authToken?.jwt)

    const initialValues = loading ? null : {status: status, shipping_track: track || "", send_email: false}

    function handleSubmit(values, actions) {
        smallEditItem(values, orderId)
            .then(() => {
                success("Orders status updated!")
            })
            .catch(err => {
                error(err)
                console.warn(err)
            })
            .finally(() => {
                actions.setSubmitting(false)
                onClose()
            })
    }

    return (
        <Modal show={true} onHide={onClose} centered>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize={true}>
                {({isSubmitting, errors, touched, submitForm, setFieldValue}) => (
                    <FormikForm>
                        <Modal.Header closeButton>
                            <Modal.Title>Manage Order</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <OurClearAlert variant="danger" msg={errorStatus} onClear={clearErrorStatus}/>

                            <SelectText name="status" label="Status">
                                {loading && <option disabled>One moment please</option>}
                                {orderStatus ?
                                    orderStatus.data.map(item => <option key={item.id} value={item.value}>{item.name}</option>)
                                    :
                                    <option disabled>No option available</option>
                                }
                            </SelectText>

                            <SingleText name="shipping_track" label="Tracking number" maxLength="32"/>


                            {errors.status && touched.status && (
                                <div className="text-danger">{errors.status}</div>
                            )}

                            {errors.shipping_track && touched.shipping_track && (
                                <div className="text-danger">{errors.shipping_track}</div>
                            )}

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onClose}>
                                Close
                            </Button>
                            <Button variant="warning" onClick={() => {
                                setFieldValue("send_email", true)
                                submitForm()
                            }}>Save & Send Email</Button>
                            <Button variant="primary" type="submit" disabled={isSubmitting}>Save</Button>
                        </Modal.Footer>
                    </FormikForm>
                )}
            </Formik>
        </Modal>
    );
}